import Vue from 'vue'

let files = new Vue({
  data () {
    return {
      documentExtensionsAllowed: ['doc', 'docx', 'gif', 'jpg', 'jpeg', 'pdf', 'png', 'ppt', 'pptx', 'txt', 'xls', 'xlsx', 'zip'],
      fileSizeAllowed: '',
      imageExtensionsAllowed: ['gif', 'jpg', 'jpeg', 'png']
    }
  },

  methods: {
    allowedFileExtension (fileName, fileType) {
      let extension = fileName.split('.').pop()
      return fileType === 'document'
        ? this.documentExtensionsAllowed.find(ext => ext === extension) !== undefined
        : fileType === 'image'
          ? this.imageExtensionsAllowed.find(ext => ext === extension) !== undefined
          : false
    },

    allowedFileSize (fileName, fileSize) {
      return true
    },

    downloadCsv (data, fileName = null) {
      let url = window.URL.createObjectURL(new Blob([data]))
      let link = document.createElement('a')
      let name = fileName === null ? 'download' : fileName
      link.href = url
      link.setAttribute('download', `${name}.csv`, 'text/html; charset=UTF-8')
      document.body.appendChild(link)
      link.click()
    }
  }
})

export default {
  install: (Vue) => {
    Vue.prototype.$files = files
  }
}
